import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { RouteEntity } from '@core/router/route.entity';
import { SafeHtmlPipe } from '@pipes/safe-html/safe-html.pipe';
import { CurrentProtocolPipe } from '@pipes/current-protocol/current-protocol.pipe';
import { Module } from '@api/models/UserService/Contract/module';
import { LoginResponse } from '@api/models/UserService/Contract/login-response';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * List modules (mobile menu)
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    imports: [
        SafeHtmlPipe,
        CurrentProtocolPipe,
        IconBsComponent,
        TranslatePipe,
        CdkTrapFocus,
    ],
})
export class MobileMenuComponent {
    /**
     * List menu items
     */
    @Input() public menuItems: Module[];
    /**
     * User data
     */
    @Input() public user: LoginResponse;

    public readonly routeEntity: typeof RouteEntity = RouteEntity;

    public readonly menuId: string = 'ui-mobile-menu-dialog';

    public isOpen: boolean = false;

    public open(): void {
        this.isOpen = true;
    }

    /**
     * Focus returns to the opener on destroy of the focus trap
     */
    public close(): void {
        this.isOpen = false;
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
